module.exports = __webpack_public_path__ + "img/P01.794c070d.jpg";